import React from 'react';

const icon6 = () => {
    return (
        <>
         <svg
                    width="40"
                    height="41"
                    viewBox="0 0 40 41"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_2481_15198"
                      maskUnits="userSpaceOnUse"
                      x="-1"
                      y="0"
                      width="41"
                      height="41"
                    >
                      <path
                        d="M39.999 0.320312H-0.000976562V40.3203H39.999V0.320312Z"
                        fill="white"
                      />
                    </mask>
                    <g mask="url(#mask0_2481_15198)">
                      <path
                        d="M8.21391 32.1055C14.7226 38.6142 25.2754 38.6142 31.7841 32.1055C38.2929 25.5967 38.2929 15.044 31.7841 8.53524C25.2754 2.0265 14.7226 2.0265 8.21391 8.53524C1.70517 15.044 1.70517 25.5967 8.21391 32.1055Z"
                        stroke="white"
                        strokeWidth="3.33333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15.285 25.0344C17.8885 27.6379 22.1096 27.6379 24.7131 25.0344C27.3166 22.4309 27.3166 18.2098 24.7131 15.6063C22.1096 13.0028 17.8885 13.0028 15.285 15.6063C12.6815 18.2098 12.6815 22.4309 15.285 25.0344Z"
                        stroke="white"
                        strokeWidth="3.33333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M31.7836 8.53534L24.7119 15.607"
                        stroke="white"
                        strokeWidth="3.33333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15.2855 25.0337L8.21387 32.1054"
                        stroke="white"
                        strokeWidth="3.33333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M31.7836 32.1054L24.7119 25.0337"
                        stroke="white"
                        strokeWidth="3.33333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15.2855 15.607L8.21387 8.53534"
                        stroke="white"
                        strokeWidth="3.33333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                  </svg>
            
        </>
    );
};

export default icon6;